// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchResult_root__rc5hQ","loading":"SearchResult_loading__UrOdp","pagination":"SearchResult_pagination__VXE99"};